import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createGeoQueryDefinitionAction, modifyGeoQueryDefinitionAction } from "../../actions";
import {
    TextField,
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Typography,
    Checkbox,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import { getActiveTypes, getRoleTypes, getMarkTypes } from "../../selectors";
import { AddIcon } from "@icarius-icons";
import { getAppColor } from "@icarius-app/selectors";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import CustomNumberFormat from "@icarius-common/dynamicInputs/customNumberFormat";

const gridStyle = { height: 75, padding: "0px 10px" };
const flexStyle = { height: 50, padding: "0px 10px", display: "flex", alignItems: "center", cursor: "pointer" };

const SelectorButton = ({ text, onClick }) => {
    const color = useSelector(getAppColor);

    return (
        <Button style={{ margin: 5 }} variant={"outlined"} disableRipple={true} onClick={onClick}>
            <AddIcon htmlColor={color} />
            {text}
        </Button>
    );
};

const QueryForm = (props) => {
    const { data, handleClose } = props;
    const dispatch = useDispatch();

    const activeTypes = useSelector(getActiveTypes);
    const roleTypes = useSelector(getRoleTypes);
    const markTypes = useSelector(getMarkTypes);

    const create = (formData) => {
        dispatch(createGeoQueryDefinitionAction(formData)).then((res) => res?.status === 200 && handleClose());
    };

    const modify = (formData) => {
        dispatch(modifyGeoQueryDefinitionAction(formData)).then((res) => res?.status === 200 && handleClose());
    };

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    };

    const openSelectorValidationError = () => {
        dispatch(
            openSnackbarAction({ msg: getLocalizedString("invalidSelectors"), severity: "error", duration: 10000 })
        );
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(
        data,
        create,
        modify,
        openValidationError,
        openSelectorValidationError
    );

    return (
        <Grid container item xs={12} direction="row" style={{ width: "95%", margin: "auto" }}>
            <Grid container item xs={12}>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* codigo */}
                    <TextField
                        disabled={!Boolean(isCreate)}
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("codeAlt")}
                        onChange={(e) => setFormValue(e.target.value, "code")}
                        value={formData.code}
                        inputProps={{ maxLength: 20 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* nombre */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("name")}
                        value={formData.name}
                        onChange={(e) => setFormValue(e.target.value, "name")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* Activa */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-active`}>
                            {getLocalizedString("activeFemale")}
                        </InputLabel>
                        <Select
                            value={formData.active}
                            labelId={`label-active`}
                            id={`select-active`}
                            onChange={(e) => setFormValue(e.target.value, "active")}
                            margin={"none"}
                        >
                            {activeTypes &&
                                activeTypes.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                    <div style={flexStyle} onClick={() => setFormValue(!Boolean(formData.showMarker), "showMarker")}>
                        {" "}
                        {/* showMarker */}
                        <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
                            {getLocalizedString("showNameInMarker")}
                        </Typography>
                        <Checkbox checked={formData.showMarker} />
                    </div>
                </div>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* sql */}
                    <TextFieldMultiline
                        required
                        fullWidth
                        label={getLocalizedString("viewSql")}
                        rows={25}
                        margin={"none"}
                        value={formData.sql}
                        onChange={(e) => setFormValue(e.target.value, "sql")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* role */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-role`}>
                            {getLocalizedString("visualizationRol")}
                        </InputLabel>
                        <Select
                            value={formData.rol}
                            labelId={`label-role`}
                            id={`select-role`}
                            onChange={(e) => setFormValue(e.target.value, "rol")}
                            margin={"none"}
                        >
                            {roleTypes &&
                                roleTypes.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* group */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("locationGroup")}
                        value={formData.group}
                        onChange={(e) => setFormValue(e.target.value, "group")}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* secuencia */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("appearanceSequence")}
                        InputProps={{ inputComponent: CustomNumberFormat }}
                        value={formData.sequence}
                        onChange={(e) => setFormValue(e.target.value, "sequence")}
                        inputProps={{
                            min: 1,
                            max: 999,
                            maxLength: 3,
                            isAllowed: (v) => v.floatValue === undefined || v.floatValue <= 999,
                        }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* labelAbrev */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("abbreviationLabels")}
                        value={formData.labelAbrev}
                        onChange={(e) => setFormValue(e.target.value, "labelAbrev")}
                        inputProps={{ maxLength: 30 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* icon */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("markerIcon")}
                        value={formData.icon}
                        onChange={(e) => setFormValue(e.target.value, "icon")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* Esquema de marcadores */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-markScheme`}>
                            {getLocalizedString("markerScheme")}
                        </InputLabel>
                        <Select
                            value={formData.markScheme}
                            labelId={`label-markScheme`}
                            id={`select-markemarkSchemer`}
                            onChange={(e) => setFormValue(e.target.value, "markScheme")}
                            margin={"none"}
                        >
                            {markTypes &&
                                markTypes.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "0px 10px" }}>
                    {" "}
                    {/* selectores */}
                    <TextField
                        required
                        fullWidth
                        helperText={
                            <>
                                {getLocalizedString("sqlSelectorTypes1")}
                                <br />
                                {getLocalizedString("sqlSelectorTypes2")}
                            </>
                        }
                        margin={"none"}
                        label={getLocalizedString("columnSelectorTypes")}
                        value={formData.selectors}
                        onChange={(e) => setFormValue(e.target.value, "selectors")}
                    />
                </Grid>
                <Grid
                    container
                    item
                    alignItems="center"
                    justify="start"
                    xs={12}
                    style={{ marginTop: 10, marginBottom: 20 }}
                >
                    <Grid container item direction="column" alignItems="start" sm={12} md={4}>
                        <SelectorButton
                            text={getLocalizedString("dropdownList")}
                            onClick={() => setFormValue(`${formData.selectors},Lista`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("date")}
                            onClick={() => setFormValue(`${formData.selectors},Fecha`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("alphanumeric")}
                            onClick={() => setFormValue(`${formData.selectors},Alfa`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("integerNumeric")}
                            onClick={() => setFormValue(`${formData.selectors},Num`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("numericWithDecimals")}
                            onClick={() => setFormValue(`${formData.selectors},Mon`, "selectors")}
                        />
                    </Grid>
                    <Grid container item direction="column" alignItems="start" sm={12} md={8}>
                        <SelectorButton
                            text={getLocalizedString("dropdownAndNotEligibleAsMarker")}
                            onClick={() => setFormValue(`${formData.selectors},ListaNone`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("dateAndNotEligibleAsMarker")}
                            onClick={() => setFormValue(`${formData.selectors},FechaNone`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("alphanumericNotEligibleAsMarker")}
                            onClick={() => setFormValue(`${formData.selectors},AlfaNone`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("integerNumericAndNotEligibleAsMarker")}
                            onClick={() => setFormValue(`${formData.selectors},NumNone`, "selectors")}
                        />
                        <SelectorButton
                            text={getLocalizedString("numericWithDecimalsAndNotEligibleAsMarker")}
                            onClick={() => setFormValue(`${formData.selectors},MonNone`, "selectors")}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ marginBottom: 35 }}>
                <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
            </Grid>
        </Grid>
    );
};

export default QueryForm;
